var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 640 640"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M581.7 188.1c-6.2-23.7-24.8-42.3-48.3-48.6C490.9 128 320.1 128 320.1 128s-170.8 0-213.4 11.5c-23.5 6.3-42 24.9-48.3 48.6C47 231 47 320.4 47 320.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8C149.3 512 320.1 512 320.1 512s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM264.2 401.6V239.2l142.7 81.2z"
})));
export default SvgYoutube;